import * as React from 'react';
import {Link, NavLink} from 'react-router-dom';

import '../../assets/style.css';
import './style.css';
import BasicDropdown from '../dropdown/BasicDropdown';

import {isBrowser, isMobile } from 'react-device-detect';
import { Close, Menu } from '@mui/icons-material';
import MobileNavElement from './MobileNavElement';

export default function Navbar({elements}){

    const [mobileVisible, setMobileVisible] = React.useState(false);

   /* const elements = [
        {
            text: 'Naslovna',
            link: '/',
            key: 'naslovna'
        },
        {
            text: 'Organizacija',
            link: '/organizacija',
            key: 'organizacija'
        },
        {
            text: 'Oblici sudjelovanja',
            link: '/oblici-sudjelovanja',
            key: 'oblici-sudjelovanja'
        },
        {
            text: 'Program',
            key: 'program',
        },
        {
            text: 'Knjiga sažetaka',
            link: '/knjiga-sazetaka',
            key: 'knjiga-sazetaka'
        },
        {
            text: 'Prijava sudjelovanja',
            link: '/prijava-sudjelovanja',
            key: 'prijava-sudjelovanja'
        },
        {
            text:"Važni datumi",
            link:'/#dates',
            key:'dates'
        },
        {
            text:"Obavijesti",
            link:'/#obavijesti',
            key:'obavijesti'
        }

    ]

    if(isMobile){
        elements[3].elements=[

            {
                text: 'Tematska područja',
                link: "/tematska-podrucja",
                key: "tematska-podrucja"
            }
        ]
    } else {
        elements[3].elements=[
                {
                    text: "Pozvani predavači",
                    link: "/pozvani-predavaci",
                    key: "pozvani-predavaci"
                },
                {
                    text: 'Tematska područja',
                    link: "/tematska-podrucja",
                    key: "tematska-podrucja"
                }
            ]
    }*/

    return (!isMobile?
        <div id="nav" className="nav-white">
            <div style={{width: "100%"}}>
                
            <div className="flex-row" style={{alignItems:"right", justifyContent:"space-around", borderTop:"7px double", borderBottom:"7px double", marginBottom:"3px"}}>
                <div style={{textAlign:"center"}}><h1 className="home-title" style={{fontFamily:"Pressio Test",fontSize:"60pt", padding:"1.5rem", borderBottom:"7px double black", marginBottom:"3px" }}>19. Tjedan psihologije</h1></div>
            <div style={{paddingTop: "3px", paddingBottom:"3px",marginBottom:"2px", borderBottom: "7px double", borderLeft:"7px double", display:"flex", flexDirection:"column", justifyContent:"center"}}>
            <div id="nav-list" style={{display:"flex", flexDirection:"row", justifyContent:"space-around"}}>
                
                {elements.map(({text, link, key, elements}, index)=>{
                    return link!=null?
                    <NavLink key={key} to={link}> <div className={"nav-link " + (index%2==0?"nav-link-even":"nav-link-odd")}>{text}</div></NavLink>
                    :<BasicDropdown key={key}  elements={elements} activeElement={<div className={"nav-link " +(index%2==0?"nav-link-even":"nav-link-odd")}>{text}</div>}/>
                    
                    
                })}
            </div>
            </div>
            </div>
            </div>
        </div>
    :<><div id="nav" className="nav-white">
        <div>
            <div className="flex-row" style={{alignItems:"baseline", justifyContent:"flex-end"}}>
                <button onClick={()=>{
                    setMobileVisible(()=>{
                        return mobileVisible?false:true
                    })
                }} id="hanbi">{mobileVisible?<Close style={{height:"2rem", width:"2rem"}}/>:<Menu style={{height:"2rem", width:"2rem"}}/>}</button>
            </div>
        </div>
    </div>
    <div id="mobile-menu" className={mobileVisible?"mobile-menu-visible nav-white":"nav-white"}>
    <MobileNavElement/>
    <div id="mobile-nav-list"  className="flex-column">
                
                {elements.map(({text, link, key, elements}, index)=>{
                  return elements!==undefined? <MobileNavElement text={text} key={index} link={link} elements={elements}/>:<MobileNavElement key={index} text={text} link={link}/>
                    
                })}
            </div>
    </div>
    </>)
}